import request from '@/utils/request'

export const getUserInfo = (data: any) =>
  request({
    url: 'user/userinfo',
    method: 'get',
    data
  })

export const login = (data: any) =>
  request({
    url: 'user/login',
    method: 'post',
    data
  })

export const logout = () =>
  request({
    url: 'users/logout',
    method: 'post'
  })
